<template>
    <Header  class="sub_menu active"></Header>

    <div class="container sub_page _news">
        <section class="sub_page_tit">
            <div class="deco_wrap">
                <i class="deco_02 "><img src="img/news_left.png"></i>
                <i class="deco_03 _xsmall spin3"><img src="img/b_icon_03.png"></i>
                <i class="deco_04 _xxsmall blink_zoom1"><img src="img/b_icon_04.png"></i>
                <i class="deco_05 _xxxsmall blink_blink1"><img src="img/b_icon_04.png"></i>
                <i class="deco_06 "><img src="img/line_circle.png"></i>
                 <i class="deco_07 _small spin_blink2"><img src="img/b_icon_01.png"></i>
                <i class="deco_08 _xsmall blink_blink3"><img src="img/b_icon_04.png"></i>
                <i class="deco_09 _xsmall blink2"><img src="img/b_icon_02.png"></i>
                <i class="deco_character"><img src="img/news_icon.png"></i>
            </div>
            <div class="banner_wrap wrap_1120">
                <h2>감시소식</h2>
            </div>
        </section>

        <NewsList></NewsList>
    </div>

    <Footer></Footer>
</template>

<script lang="ts" config>
    import { Header, Footer, reactive, globalStore, onMounted, watch, newsList } from "@/BaseComponent";

    export default {
        components: { Header, Footer, NewsList: newsList },
        setup() {
            const global = globalStore();
            const state = reactive({
                tab: 0 as number,
            });

            const changeTab = (tab: number) => {
                state.tab = tab;
            };

            onMounted(() => {
                if (global.introTab > 0) changeTab(global.introTab);
                else changeTab(1);
            });

            watch(state, () => {
                if (global.introTab !== state.tab) global.setIntroTab(state.tab);
            });

            watch(global, () => {
                if (global.introTab !== state.tab) changeTab(global.introTab);
            });

            return { state, changeTab };
        },
    };
</script>
